import Sanitizer from 'sanitizer'

const VueSanitizer = {
  install(app) {
    app.config.globalProperties.$sanitize = (input) => {
      /**
       * params {String}
       * return {String}
       */
      return Sanitizer.sanitize(
        input,
        (uri) => {
          return uri
        }
      )
    }
  }
}

export default VueSanitizer
